import { CustomizeSpecTable } from "~/components/Document/tables";
import type { Document as AppDocument } from "~/interface/document";

interface HistoryCustomizeSpecificationProps {
  formData: AppDocument[];
}

const HistoryCustomizeSpecification = ({ formData }: HistoryCustomizeSpecificationProps) => {
  return <CustomizeSpecTable formData={formData} mode="full" />;
};

export default HistoryCustomizeSpecification;
